<app-landing-toolbar *ngIf="authService.currentUserId === 'anonymous'"></app-landing-toolbar>
<div class="wrapper" [ngClass]="authService.currentUserId === 'anonymous' ? 'main-substitution' : ''">
    <div class="name-and-format-row">
        <b class="title-font">{{deck?.name}} -- {{deck?.format}} ({{deck?.totalQuantity}} Cards)</b>
        <button mat-icon-button [color]="likeButtonColor" (click)="toggleLikeDeck()" matTooltip="Likes" gtagEvent trackOn="click" action="upvote_Deck" category="decks">
            <mat-icon [innerHTML]="likeIconName"></mat-icon> {{deck?.upvoteCount}}
        </button>
    </div>
    <div *ngIf="deck?.format === 'Two Headed Giant'">Note! Not enforcing rules for this format!</div>
    <div class="focus-row">
        <div class="focused-card">
            <app-card-image [card]="focusedCard | async" [width]="225" [clickable]="false" [hoverable]="false" [draggable]="false"></app-card-image>
        </div>
        <div class="cmc-histo">
            <app-histogram [data]="cmcHisto | async" title="CMC Histogram" xAxesLabel="cmc" yAxesLabel="Count"
                           barPercentage="1.25"></app-histogram>
        </div>
        <!-- TODO: We need a better visualization for mana balance. The Radar diagram is only useful for niche decks -->
        <!--       like 4 or 5 color commanders. Leaving this hear for a reminder that this needs handled -->
        <!--        <div class="mana-balance">-->
        <!--            <app-radar [data]="manaBalance | async" title="Mana Balance"-->
        <!--                       [labels]="['Red', 'Blue', 'Black', 'Green', 'White', 'Colorless']"></app-radar>-->
        <!--        </div>-->
        <div class="type-compositions">
            <app-histogram [data]="typeCompositions | async" title="Type Composition" xAxesLabel="Type"
                           yAxesLabel="Count"></app-histogram>
        </div>
        <div class="color-stats">
            <app-pie-chart title="Color Composition"
                           [sectionColors]="['#f2eeca', '#aae1fa', '#cac0be', '#f5a78d', '#96cda9', '#c7d4f2']"
                           [sectionLabels]="['White', 'Blue', 'Black', 'Red', 'Green', 'Colorless']"
                           [data]="colorStats | async"></app-pie-chart>
        </div>
    </div>
    <mat-slide-toggle class="summary-toggle" [(ngModel)]="showSummary" gtagEvent trackOn="click" action="toggle_summary_public" category="decks" [params]="{ deck_id: deck ? deck.id : 'null', deck_format: deck ? deck.format : 'null', user_id: authService.currentUserId }">Summary View</mat-slide-toggle>
    <div class="deck-and-cards-row" *ngIf="deck">
        <div class="deck-and-summary" cdkDropList [cdkDropListSortingDisabled]="true" id="user-deck">
            <div *ngIf="showSummary" class="deck-summary">
                <app-deck-summary [deck]="deck" [cardsRemovable]="false" [format]="format" [style.width]="'100%'" (cardActionTaken)="forceUpdate()"></app-deck-summary>
            </div>
            <div *ngIf="!showSummary" class="deck">
                <app-card-table [cards]="deck?.cards" tableId="deck-table" [columns]="columns" [totalSize]="deck?.filteredCardCount"
                                (newQuery)="queryUpdated.next($event)" (pagingChanged)="pageUpdated.next($event)"
                                [isValid]="cardValidator"
                                (cardActionTaken)="forceUpdate()"
                                [style.width]="'100%'" [addCardsToDeck]="false"></app-card-table>
            </div>
        </div>
    </div>
    <mat-error *ngIf="invalidCards.size">Invalid cards for the format are marked with red ({{invalidCards.size}} unique card names are invalid)</mat-error>
</div>
